module.exports = __webpack_public_path__ + "img/refresh.225cbb87.svg";